import { getENV } from './env';

export interface BranchConfig {
    branchKey: string | undefined;
    enableJourneys?: boolean;
    debug?: boolean;
    branchScriptUrl: string;
}

export const getBranchConfig = (): BranchConfig => {
    const { NEXT_PUBLIC_BRANCH_KEY, NEXT_PUBLIC_APP_ENV } = getENV();
    const isProd = NEXT_PUBLIC_APP_ENV === 'prod';

    return {
        branchKey: NEXT_PUBLIC_BRANCH_KEY,
        enableJourneys: true,
        debug: !isProd,
        branchScriptUrl: 'https://cdn.branch.io/branch-latest.min.js',
    };
};

export interface BranchInitConfig {
    branch_key?: string;
    enable_journeys?: boolean;
    debug?: boolean;
}

interface BranchSDK {
    init: (
        branchKey: string | undefined,
        options?: BranchInitConfig,
        callback?: (err: Error | null, data: unknown) => void
    ) => void;
    track: (event: string, metadata?: unknown) => void;
}

declare global {
    interface Window {
        branch?: BranchSDK;
    }
}

export function trackBranch(event: string, metadata?: unknown) {
    window.branch?.track(event, metadata);
}
